export default __webpack_public_path__ + "static/media/song3.e330b42d.mp3";